export default __webpack_public_path__ + "static/media/favicon.ee353c67.ico";